import React from 'react';

import classes from './Checkbox.module.scss';

import { FormattedMessage } from 'react-intl';

const checkbox = ( props ) => {
    let inputElement = null;
    const inputClasses = [classes.InputElement, 'InputElement'];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }

    inputElement = <input
                type="checkbox"
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                checked={props.checked}
                onChange={props.changed} />;
    
    
    let label;
    if(props.label) {
        label = (<label className={classes.Label}><FormattedMessage id={props.id} defaultMessage={props.label}>{(msg) => msg}</FormattedMessage></label>)
    } else {
        label = (props.icon) ? (<label className={classes.Label}><img alt='' src={ props.icon }/></label>) : "";
    }
    
    let frontLabel = "";
    if(props.frontLabel) {
        frontLabel = (<label className={classes.Label}>{ props.frontLabel }</label>);
    }
    
    return (
        <div className={[classes.Input, "checkbox"].join(' ')}>
            { frontLabel }
            { inputElement }
            { label }
        </div>
    );

};

export default checkbox;
